import {
  Box,
  Button,
  Checkbox,
  FormControl,
  FormControlLabel,
  FormHelperText,
  InputLabel,
  LinearProgress,
  Link,
  MenuItem,
  Modal,
  Radio,
  RadioGroup,
  Select,
  Snackbar,
  TextField,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import CloseIcon from "@mui/icons-material/Close";
import states from "../json/state.json";
import { useRouter } from "next/router";
import ReCAPTCHA from "react-google-recaptcha";

const MembershipModal = ({ membershipOpen, setMembershipOpen }) => {
  const router = useRouter();
  const location = useRouter();
  const { pathname } = location;

  const recaptchaRef = React.createRef();

  const [interestValueFlase, setInterestValueFlase] = useState(false);
  const [interestValueTrue, setInterestValueTrue] = useState(false);
  const [interestValueBoth, setInterestValueBoth] = useState(false);
  const [submitLoder, setSubmitLoder] = useState(false);
  const [snackbarState, setSnackbarState] = useState(false);

  const [snackMsg, setSnackMsg] = useState("");


  const [user, setUser] = useState({ user_type: "is_astrologer" });
  const [error, setError] = useState({});
  const [loader, setLoader] = useState(false);

  const handleNewwClosee = () => {
    setMembershipOpen(false);
  };



  const handelCheckbox = (e, type) => {
    // e.preventDefault()
    console.log("handelCheckbox", type);
    if (type == "Astrology") {
      setInterestValueFlase(false);
      setInterestValueTrue(true);
      setInterestValueBoth(false);
    } else if (type == "both") {
      setInterestValueFlase(true);
      setInterestValueTrue(true);
      setInterestValueBoth(true);
    } else {
      setInterestValueFlase(true);
      setInterestValueTrue(false);
      setInterestValueBoth(false);
    }
    // setChecboxValue(e.target.value);
    console.log("e============>>>>>", e.target.value);
    let value = e.target.value;
    let interested_in = [];
    setUser({ ...user, interested_in: value });
    if (value == "") {
      setError({ ...error, interested_in: undefined });
    }
  };



  useEffect(()=>{
    console.log("user",user);
  },[user])


  const handleInput = (e) => {
    // console.log("value========", e);
    e.preventDefault();
    let name = e.target.name;
    let value = e.target.value;
    if (name === "state") {
      setError({ ...error, [name]: undefined });
    }

    setUser({ ...user, [name]: value });
  };

  const phoneFormatting = (event) => {
    // console.log("event", event)
    if (event.target.value.split("").length <= 14) {
      let formatted = formatPhoneText(event.target.value);
      let name = event.target.name;
      user.phone = formatted;
      setUser({ ...user, [name]: formatted });
    }
  };

  function formatPhoneText(value) {
    value = value.trim().replaceAll("-", "");
    value = value.trim().replaceAll("(", "");
    value = value.trim().replaceAll(")", "");
    value = value.trim().replaceAll(" ", "");

    if (value.length > 3 && value.length <= 6)
      value = "(" + value.slice(0, 3) + ")" + " " + value.slice(3);
    else if (value.length > 6)
      value =
        "(" +
        value.slice(0, 3) +
        ")" +
        " " +
        value.slice(3, 6) +
        "-" +
        value.slice(6);
    return value;
  }

  const [tokenGen, setTokenGen] = useState("");
  useEffect(() => {
    console.log("tokenGen===========", tokenGen);
  }, [JSON.stringify(tokenGen)]);

  // useEffect(() => {
  //   console.log(user);
  // }, [user]);

  // ===============for error object initial value============
  let errorObject = {};

  useEffect(() => {
    console.log("errorObject========", errorObject);
  }, [errorObject]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!user?.firstname) {
      errorObject.firstname = "First Name is Required";
    }
    if (!user?.email) {
      errorObject.email = "Email is Required";
    } else if (!/\S+@\S+\.\S+/.test(user.email)) {
      errorObject.email = "* Invalid email format";
    }
    if (!user?.lastname) {
      errorObject.lastname = "Last Name is Required";
    }
    if (!user?.city) {
      errorObject.city = "City is Required";
    }
    if (!user?.phone) {
      errorObject.phone = " Telephone Number is Required";
    }

    if (!user?.state) {
      errorObject.state = "State is Required";
    }

    if (!user?.zip) {
      errorObject.zip = "Zip is Required";
    }
    if (user) {
      user.type = "Membership";
    }
    if (!user?.interested_in) {
      errorObject.interested_in = "Please Choose One";
    }
    if (!user?.best_time_to_call) {
      errorObject.best_time_to_call = "Best Time To Call is Required";
    }
    if (tokenGen == "") {
      errorObject.tokenGen = "Prove you are not a robot";
    }
    if (Object.keys(errorObject).length > 0) {
      setError(errorObject);
      console.log("error exeist", errorObject);
    } else {
      setLoader(true);

      setError({});

      setSubmitLoder(true);

      let requestOptions = {
        method: "POST",
        // mode:'no-cors',
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(user),
      };
      console.log("user=========>", user);
      try {
        let req = await fetch(
          `${process.env.NEXT_PUBLIC_BACKEND_URL}membership/addedit`,
          requestOptions
        );
        console.log("req", req);
        let res = await req.json();
        if (res.status === "success") {
          console.log("res status=======>", res);
          setSnackbarState(true);
          setSnackMsg(res.message);
          setUser(null);
          setSubmitLoder(false);
          setTimeout(() => {
            setMembershipOpen(false);
          }, 2000);
          setUser(null);
          setInterestValueFlase(false);
          setInterestValueTrue(false);
          setInterestValueBoth(false);
        } else {
          console.log("res error=======>", res);
          setSnackbarState(true);
          setSnackMsg(res.message);
          setSubmitLoder(false);
        }
      } catch (error) {
        console.log(error, "this is submit error");
        setSubmitLoder(false);
      }
      console.log("userObjectSet=========>>>>>", user);

      // setSubmitLoder(false);/
      // setSnackbarState(true);
    }
  };



  const closeSnack = () => {
    setSnackbarState(false);
  };

  return (
    <>
      <Modal
        open={membershipOpen}
        onClose={handleNewwClosee}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        className="banner_modal_main banner_modal_main_new membership_modal_main_wrapper"
      >
        <div className="membership_modal_wrp">
          <span className="close_btn" onClick={handleNewwClosee}>
            <CloseIcon />
          </span>
          <Box className="banner_modal_box_new banner_modal_box_neww">
            <Typography
              id="modal-modal-description" component="div"
              sx={{ mt: 2 }}
              className="modal_banner_new"
            >
              <div className="sub_modal_banner_new">
                {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/assets/images/logobanner.webp" alt="bannerLogo" /> */}
                <div className="mdl_hdr">
                  <h2>Our Inner Mystery School offers a profound 15-month program, meticulously aligned with the astrological year and enriched by the disciplines of ROTA (Tarot Alchemy) and Theurgic Ritual Praxis. Participants are granted access to 10-day ritual intervals based on the ancient Egyptian Decan system, which intricately connects to the invocations of deities and the Greek daemonic system. As you advance, Eddie's personal audio journals and comprehensive instructions become accessible through a secure online back office. These resources are methodically unlocked according to the zodiacal period over the course of twelve months. </h2>
                  <h2>
                  In the initial three months, a commitment of at least five hours weekly is essential for training and ritual immersion. Subsequently, during the 12-month core phase, participants are expected to dedicate at least one day for each Decan—though greater engagement is encouraged—to deepen their understanding and practice, supported by Eddie's extensive audio journal insights for each 10-day segment.
                  </h2>
                  <h2>
                  The inaugural session of the Inner Mystery School commences on the Spring Equinox of 2026.
                  </h2>
                  <h4>
                    <Link
                      onClick={() => {
                        router.push(
                          "/tarot-astrology-certification?coursesmetrics"
                        );
                        handleNewwClosee();
                      }}
                      className="linkText8"
                    >
                      If you would like to be considered as an Aspirant of the Inner Mystery School please fill out this form.
                    </Link>
                  </h4>
                </div>

                <div className="gred_txt">
                  <h3>
                    If you would like to be informed when the Inner Mystery
                    School is <br />
                    <span>open please fill out this form</span>
                  </h3>
                </div>

                <div className="modle_form_sec_wrapper">
                  <div className="mdl_form_sec">
                    <form className="mdl_form">
                      <div className="mdl_form_flex">
                        <TextField
                          className="from_input form_field_wrapperfname"
                          id="outlined-basic"
                          name="firstname"
                          value={user?.firstname ? user.firstname : ""}
                          onChange={handleInput}
                          error={error.firstname ? true : false}
                          helperText={error.firstname}
                          onKeyDown={() => {
                            error.firstname = "";
                          }}
                          // label="Email*"
                          variant="outlined"
                          label="First Name"
                        />
                        <TextField
                          className="from_input form_field_wrapperstate"
                          id="outlined-basic"
                          name="lastname"
                          value={user?.lastname ? user.lastname : ""}
                          onChange={handleInput}
                          error={error?.lastname ? true : false}
                          helperText={error.lastname}
                          onKeyDown={() => {
                            error.lastname = "";
                          }}
                          // label="Email*"
                          variant="outlined"
                          label="Last Name"
                        />

                        <TextField
                          className="from_input"
                          id="outlined-basic"
                          name="email"
                          value={user?.email ? user.email : ""}
                          onChange={handleInput}
                          error={error.email ? true : false}
                          helperText={error.email}
                          onKeyDown={() => {
                            error.email = "";
                          }}
                          // label="Email*"
                          variant="outlined"
                          label="Email Address"
                        />

                        <TextField
                          label="Telephone Number      "
                          className="from_input"
                          variant="outlined"
                          fullWidth={true}
                          name="phone"
                          type="text"
                          onKeyPress={(e) => {
                            error.phone = "";
                            if (e.which < 48 || e.which > 57) {
                              e.preventDefault();
                            } else {
                              let input = e.target.value;
                              let result = input.replace(/\D/g, "");
                              console.log(input, result, "suyagudsa");
                            }
                          }}
                          onChange={(e) => phoneFormatting(e)}
                          value={user?.phone}
                          error={error?.phone ? true : false}
                          helperText={error?.phone}
                        />
                        <TextField
                          label="City"
                          className="from_input"
                          id="outlined-basic"
                          name="city"
                          value={user?.city ? user.city : ""}
                          onChange={handleInput}
                          error={error.city ? true : false}
                          helperText={error.city}
                          onKeyDown={() => {
                            error.city = "";
                          }}
                          // label="Email*"
                          variant="outlined"
                        />

                        <FormControl className="from_input form_field_wrapperstate">
                          <InputLabel id="demo-simple-select-helper-label">
                            State
                          </InputLabel>
                          <Select
                            className="contact_select_menu"
                            id="demo-simple-select-helper"
                            label="Select State"
                            name="state"
                            onChange={handleInput}
                            value={user?.state ? user.state : ""}
                            error={error.state ? true : false}
                          >
                            {states.map((item, key) => {
                              return (
                                <MenuItem
                                  className="contact_menu_item"
                                  value={item.val}
                                  key={key}
                                >
                                  {item.name}
                                </MenuItem>
                              );
                            })}
                          </Select>
                          {error.state && (
                            <FormHelperText id="my-helper-text">
                              {error.state}
                            </FormHelperText>
                          )}
                        </FormControl>

                        <TextField
                          label="Zip"
                          className="from_input"
                          id="outlined-basic"
                          name="zip"
                          value={user?.zip ? user.zip : ""}
                          onChange={handleInput}
                          error={error.zip ? true : false}
                          helperText={error.zip}
                          onKeyDown={() => {
                            error.zip = "";
                          }}
                          // label="Email*"
                          variant="outlined"
                        />

                        {/* <div className="from_input_new from_input_flx">
                          <div className="from_input from_input_flx">
                            <h5>Interested in</h5>
                            <span className="chkbox chkbox_member">
                              {user?.interested_in ? (
                                ""
                              ) : (
                                <FormHelperText id="my-helper-text">
                                  {error?.interested_in && error.interested_in}
                                </FormHelperText>
                              )}

                              <FormControlLabel
                                onChange={(e) => handelCheckbox(e, "Astrology")}
                                checked={interestValueTrue}
                                control={<Checkbox value="Astrology" />}
                                label="Astrology"
                                labelPlacement="start"
                              />
                              <FormControlLabel
                                onChange={(e) => handelCheckbox(e, "Tarot")}
                                checked={interestValueFlase}
                                control={<Checkbox value="Tarot" />}
                                label="Tarot"
                                labelPlacement="start"
                              />
                              <FormControlLabel
                                onChange={(e) => handelCheckbox(e, "both")}
                                checked={interestValueBoth}
                                control={<Checkbox value="Both" />}
                                label="Both"
                                labelPlacement="start"
                              />
                            </span>
                          </div>
                        </div> */}
                        
                      </div>
                      <div className="from_input_flx_new wdth100 from_input">
                        <span className="call_txt">Best time to call </span>
                        <span className="chkbox radio_member">
                          <FormControl>
                            <RadioGroup
                              aria-labelledby="demo-radio-buttons-group-label"
                              name="best_time_to_call"
                              onChange={handleInput}
                              value={
                                user?.best_time_to_call
                                  ? user.best_time_to_call
                                  : ""
                              }
                              className="radio_wrrp"
                            >
                              <FormControlLabel
                                value="Morning"
                                control={<Radio />}
                                label="Morning"
                                labelPlacement="start"
                                className="radio"
                              />
                              <FormControlLabel
                                value="Midday"
                                control={<Radio />}
                                label="Mid day"
                                labelPlacement="start"
                                className="radio"
                              />
                              <FormControlLabel
                                value="Evening"
                                control={<Radio />}
                                label="Evening"
                                labelPlacement="start"
                                className="radio"
                              />
                            </RadioGroup>
                          </FormControl>
                          {user?.best_time_to_call ? (
                            ""
                          ) : (
                            <FormHelperText id="my-helper-text">
                              {error?.best_time_to_call &&
                                error.best_time_to_call}
                            </FormHelperText>
                          )}
                        </span>

                        <div className="reCaptcha_wrpr" style={{position:"relative"}}>
                          <ReCAPTCHA
                            ref={recaptchaRef}
                            sitekey={process.env.reCaptchaSite_key}
                            onChange={(e) => {
                              // console.log("eeee===>", e);
                              setTokenGen(e);
                              e.length>0 ? setError({...error, tokenGen: undefined }): setError({...error, tokenGen: "Prove you are not a robot" })
                            }}
                          />
                          <FormHelperText id="recaptchaid" style={{position: "absolute"}} className="captchaError">
                            {error.tokenGen}
                          </FormHelperText>
                        </div>
                      </div>

                      <div className="btn_wrpr">
                        <Button onClick={handleSubmit}>SUBMIT</Button>
                      </div>
                      {submitLoder && (
                        <Box sx={{ width: "100%" }}>
                          <LinearProgress />
                        </Box>
                      )}
                    </form>
                  </div>
                </div>
              </div>
            </Typography>
          </Box>
        </div>
      </Modal>
      <Snackbar
        open={snackbarState}
        autoHideDuration={3000}
        onClose={() => closeSnack()}
        className="snackbarClass"
        message={snackMsg}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      />
    </>
  );
};

export default MembershipModal;
